import { selectFeatureFlags } from 'core/userContext';
import { JOURNEY_EVENTS_METRICS } from 'modules/billing/constants';
import { useProjectUsage } from 'modules/billing/hooks/useProjectUsage';
import { useSelector } from 'react-redux';
import { queryByFn } from '../../utils';
import { SimpleIndexPage } from '../SimpleIndexPage/SimpleIndexPage';
import { ProjectUsagePageActions } from './ProjectUsagePageActions';
import { createRowCell } from './TableCell';
import { useLocation } from 'react-router';

export const JourneyEventsProjectUsage = () => {
  const { search } = useLocation();
  const { JourneyExitEvents } = useSelector(selectFeatureFlags);
  const { breadcrumb, columns, isLoading, rows } = useProjectUsage([
    JOURNEY_EVENTS_METRICS.jvtCount,
  ]);

  /** add an href property to each row to link to project */
  const rowsWithHref = rows.map((row) => ({
    ...row,
    href: `/payments/info/journeyEventsUsage/${row.projectId}${search}`,
  }));

  return (
    <>
      {JourneyExitEvents && (
        <SimpleIndexPage
          breadcrumb={breadcrumb}
          columns={columns}
          createRowCell={createRowCell}
          isLoading={isLoading}
          pageActions={<ProjectUsagePageActions />}
          pageTitle="Journey events usage"
          queryByFn={queryByFn}
          rows={rowsWithHref}
        />
      )}
    </>
  );
};
